export default "__VITE_ASSET__D6hW9mQC__"